let adsOn = true;
document.getElementById('ads-toggle').addEventListener('click', () => {
  adsOn = !adsOn;
  const t = document.getElementById('ads-track');
  adsOn ? t.classList.add('on') : t.classList.remove('on');
  update();
});
function fmt(n){ return '$' + n.toFixed(2); }
function pct(n,total){ return (n/total*100).toFixed(1)+'%'; }
function bar(label, amt, maxFee, color){
  const w = Math.min(100, maxFee > 0 ? (amt/maxFee)*100 : 0);
  return `<div class="fv-bar-row">
    <div class="fv-bar-label">${label}</div>
    <div class="fv-bar-track"><div class="fv-bar-fill" style="width:${w.toFixed(1)}%;background:${color}"></div></div>
    <div class="fv-bar-amt">${fmt(amt)}</div>
  </div>`;
}
function update(){
  const price = +document.getElementById('price').value;
  const ship  = +document.getElementById('ship').value;
  const total = price + ship;
  document.getElementById('price-out').textContent = '$' + price;
  document.getElementById('ship-out').textContent  = '$' + ship;
  document.getElementById('seller-note').textContent = 'Total sale to buyer: ' + fmt(total);

  // Etsy fees (source: help.etsy.com/hc/en-us/articles/115014483627)
  const listing = 0.20;                          // flat $0.20 per sale
  const txn     = total * 0.065;                 // 6.5% of total incl. shipping
  const proc    = total * 0.03 + 0.25;           // 3% + $0.25 US rate
  const ads     = adsOn ? total * 0.12 : 0;      // 12% for shops over $10K/yr
  const etsy    = listing + txn + proc + ads;

  // Shopify Payments Basic (source: shopify.com/pricing — annual plan $29/mo)
  // Online card rate: 2.9% + $0.30 (confirmed June 2026)
  const shopifyProc = total * 0.029 + 0.30;

  const maxFee = Math.max(etsy, shopifyProc + 0.5);

  let eBars = bar('Listing ($0.20)', listing, maxFee, '#464646')
    + bar('Transaction 6.5%', txn, maxFee, '#888787')
    + bar('Processing 3%+$0.25', proc, maxFee, '#BBBBBB');
  if(adsOn) eBars += bar('Offsite Ads 12%', ads, maxFee, '#EB2529');
  document.getElementById('etsy-bars').innerHTML = eBars;
  document.getElementById('etsy-pct').textContent  = pct(etsy, total);
  document.getElementById('etsy-abs').textContent  = fmt(etsy) + ' of ' + fmt(total);
  document.getElementById('etsy-keep').textContent = 'You keep: ' + fmt(total - etsy);

  const sBars = bar('Payments 2.9%+$0.30', shopifyProc, maxFee, '#EB2529');
  document.getElementById('shopify-bars').innerHTML  = sBars;
  document.getElementById('shopify-pct').textContent  = pct(shopifyProc, total);
  document.getElementById('shopify-abs').textContent  = fmt(shopifyProc) + ' of ' + fmt(total);
  document.getElementById('shopify-keep').textContent = 'You keep: ' + fmt(total - shopifyProc) + ' (+ $29/mo plan separately)';
}
document.getElementById('price').addEventListener('input', update);
document.getElementById('ship').addEventListener('input', update);
update();
